// ===========================================
// Where an invoice-dialog link opens (#376 whole-feature QA, W1)
// ===========================================
// The Auto Generate results are the only record of a run (who was held back, which invoice's
// discounts failed). A same-tab link unmounts the dialog and the report is gone. Inside the report,
// links open in a NEW tab; everywhere else (Create Invoice) they stay same-tab. A context, not a
// prop, so the shared link components keep their exact call sites.

import { createContext, useContext } from 'react';

const OpenLinksInNewTab = createContext(false);

export const OpenLinksInNewTabProvider = OpenLinksInNewTab.Provider;

/** Props to spread on a RouterLink: a new tab inside the run report, same tab elsewhere. */
export function useLinkTargetProps(): { target?: string; rel?: string } {
  return useContext(OpenLinksInNewTab) ? { target: '_blank', rel: 'noopener' } : {};
}
